import {
  Controller,
} from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    setTimeout(() => { this.element.remove(); }, parseInt(this.element.dataset.time, 10));
  }
}
